import React from "react";
import TextInput from "./element/TextInput";
import DeleteButton from "./element/DeleteButton";

function FormList({
  item,
  proficiencyType,
  itemId,
  listId,
  updateData,
  removeData,
}) {
  function handleItemChange(e) {
    updateData({
      category: "list",
      mainId: listId,
      subId: itemId,
      subCategory: proficiencyType,
      property: e.target.name,
      newValue: e.target.value,
    });
  }
  function handleDelete() {
    removeData({ category: "itemList", mainId: listId, subId: itemId });
  }
  if (proficiencyType === "none") {
    return (
      <>
        <div className="flex gap-4">
          <div>
            <TextInput
              labelText="List Item:"
              inputName="name"
              inputOnChange={handleItemChange}
              inputValue={item.name}
            />
          </div>
          <div className="mt-0.5">
            <DeleteButton handleDelete={handleDelete} text={"Add item"} />
          </div>
        </div>
      </>
    );
  } else if (proficiencyType === "level") {
    return (
      <>
        <div className="flex gap-4">
          <div>
            <TextInput
              labelText="List Item:"
              inputName="name"
              inputOnChange={handleItemChange}
              inputValue={item.name}
            />
            <TextInput
              labelText="Proficiency:"
              inputName="proficiency"
              inputOnChange={handleItemChange}
              inputValue={item.proficiency}
            />
          </div>{" "}
          <div className="mt-0.5">
            <DeleteButton handleDelete={handleDelete} text={"Add item"} />
          </div>{" "}
        </div>
      </>
    );
  } else if (proficiencyType === "score") {
    return (
      <>
        <div className="flex gap-4">
          <div>
            <TextInput
              labelText="List Item:"
              inputName="name"
              inputOnChange={handleItemChange}
              inputValue={item.name}
            />
            <div className="flex mb-2">
              <label htmlFor="proficiency">Proficiency:</label>

              <input
                className=" border rounded-sm pl-2 pr-0.5  mb-1 bg-inherit outline-0 focus:border-slate-700 hover:border-slate-400"
                type="number"
                min="0"
                max="5"
                name="proficiency"
                onChange={handleItemChange}
                value={parseInt(item.proficiency)}
              />
            </div>
          </div>
          <div className="mt-0.5">
            <DeleteButton handleDelete={handleDelete} text={"Add item"} />
          </div>{" "}
        </div>
      </>
    );
  }
}

export default FormList;
